export default __webpack_public_path__ + "static/desert-5538903e02461c4dc690561e2e296941.webp";